import { getWindowData } from 'owa-window-data';
import { isStandaloneMyOutlook } from './isStandaloneMyOutlook';

export function isHosted(): boolean {
    // metaos and opx are both hosted experiences
    return (
        !isStandaloneMyOutlook() &&
        (getWindowData()?.location?.pathname.indexOf('/hosted') == 0 ||
            getWindowData()?.location?.pathname.indexOf('/opx') == 0)
    );
}
